<template>
  <Layout>
    <ChiWarning
      type="warning"
      title="Continue with your application"
      text="<p>CHI needs to gather more information about you and your family before your match is considered. Advance the analysis by filling out and submitting the form below.</p>"
    />

    <div v-if="aupair">
      <ChiCard title="Complete your initial application">
        <div class="flex flex-col justify-center items-center">
          <Photo
            class="m-auto"
            :src="aupair.profilePhoto"
            :alt="aupair.firstName"
          />
          <AuPairName class="text-4xl mt-5 mb-12" :name="aupair.firstName" />

          <button
            @click.prevent="cancelMatch(aupair.auPairPromoProfileId)"
            class="btn btn-purple"
          >
            Cancel Interest
          </button>
        </div>
      </ChiCard>

      <div class="mt-10">
        <ChiCard>
          <ApplicationForm />
        </ChiCard>
      </div>
    </div>
    <ComponentLoading v-else />
  </Layout>
</template>

<script>
import { api } from "@/services.js";
import Layout from "@/Layout/Authenticated/Layout.vue";

import ChiWarning from "@/components/UI/ChiWarning.vue";
import ChiCard from "@/components/UI/ChiCard.vue";
import AuPairName from "@/components/AuPairs/AuPairCardItems/AuPairName.vue";
import Photo from "@/components/AuPairs/AuPairCardItems/Photo.vue";

import ApplicationForm from "@/components/Forms/ApplicationForm.vue";
export default {
  name: "MatchRequest",
  components: {
    Layout,
    AuPairName,
    Photo,
    ApplicationForm,
    ChiWarning,
    ChiCard,
  },
  data() {
    return {
      aupair: null,
    };
  },
  computed: {
    profilePhoto() {
      return `https://ap2.chinet.org/api/v1.0${this.aupair.profilePhoto}/sm`;
    },
  },
  created() {
    if (this.$store.state.user.match) {
      this.$router.push({
        name: "Home",
      });
    } else {
      const id = this.$store.state.user.matchRequest;
      api.get(`/promotional/AuPairPromoProfiles/${id}`).then((r) => {
        this.aupair = r.data;
      });
    }
  },
  methods: {
    cancelMatch(id) {
      api
        .delete(`/promotional/AuPairPromoProfiles/${id}/matchRequest`)
        .then(() => {
          this.$store.dispatch("getUser");
          this.$router.push({ name: "RequestInterview" });
          this.$toasted.global.notificate({
            message: "Your interest request was cancalled.",
            type: "success",
          });
        })
        .catch((error) => {
          this.$toasted.global.notificate({
            message: error.response.data.message,
            type: "error",
          });
        });
    },
  },
};
</script>
